/**
 * @version 1.0
 * @author Kelnik Studios {http://kelnik.ru}
 */
import aboutBalloonTemplate from './balloon/about.twig';
import aboutMarkerTemplate from './marker/about.twig';
import balloonTemplate from './balloon/default.twig';
import commerceBalloonTemplate from './balloon/commerce.twig';
import commerceMarkerTemplate from './marker/commerce.twig';
import contactsMarkerTemplate from './marker/contacts.twig';
import {DESKTOP_BREAKPOINT} from '../../common/scripts/constants';
// eslint-disable-next-line
// import {JsonPopup} from '../popup/popup';
// eslint-disable-next-line
import infrastructureBalloonTemplate from './balloon/infrastructure.twig';
import infrastructureMarkerTemplate from './marker/infrastructure.twig';
import mapUtils from './utils';
import markerTemplate from './marker/default.twig';
import Panel from './panel';

const panel = new Panel();
// const popup = new JsonPopup({openButtons: }).init();

class Marker {
    constructor() {
        /**
         * Объект яндекс карт
         */
        this.ymaps = window.ymaps;

        /**
         * Брейкпоинт после которого маркеры открываются не по клику, а по ховеру.
         * @type {number}
         */
        this.desktopBreakpoint = DESKTOP_BREAKPOINT;
    }

    /**
     * Создает HTML маркер
     * @param {object} element - элемент массива маркеров
     * @returns {function} функции инициализации маркера на карте параметрического поиска
     * @public
     */
    createHtmlMarker(element) {
        this._setTemplateMarker(element);
        this._setTemplateBalloon(element);
        this.balloon = element;

        const CustomLayoutClass = this._createMarkerFromTemplate(element);
        const zIndex = element.zIndex || false;
        const isBalloon = element.balloon;
        const balloonLayout = mapUtils.needBalloonPanel() || !isBalloon ?
            false :
            this._createBalloonContentLayout();
        const cursor = isBalloon || element.modifyClass === 'office' ? 'pointer' : 'default';

        const marker = new this.ymaps.Placemark(element.coords, {}, {
            type                  : 'Placemark',
            balloonLayout,
            iconLayout            : CustomLayoutClass,
            hideIconOnBalloonOpen : this.hideIconOnBalloonOpen,
            // текущий шаблон для баллуна
            template              : this.balloonTemplate,
            // все данные от бэкенда
            data                  : element,
            // z-index для маркера
            zIndex,
            panel,
            cursor,
            isBalloon,
            balloonPanelMaxMapArea: 0
        });

        this._bindEventsMarker(marker);

        // Для табов, если есть такой флаг то изначально маркер будет скрыт
        if (element.isHidden) {
            marker.options.set('visible', false);
        }

        return marker;
    }

    /**
     * Создает HTML маркер с определением размера маркера и оффсетами
     * @param {object} element - элемент массива маркеров
     * @return {object} - элемент маркера
     * @private
     */
    // eslint-disable-next-line max-lines-per-function
    _createMarkerFromTemplate(element) {
        return this.ymaps.templateLayoutFactory.createClass(this.markerTemplate(element), {
            build() {
                this.constructor.superclass.build.call(this);
                this._$element = $(`.j-yandex-map-marker`, this.getParentElement());
                this._$officeElement = $(`.yandex-map__office-marker-img`, this.getParentElement());
                this._options = this.getData().options;
                this._size = [this._$element[0].offsetWidth, this._$element[0].offsetHeight];
                if (this._$officeElement.length) {
                    this._officeOffset = [this._$officeElement[0].offsetWidth, this._$officeElement[0].offsetHeight];
                }
                this._offset = this._calcElementOffset();

                const iconShape = {
                    type       : 'Rectangle',
                    coordinates: [this._offset, [this._offset[0] + this._size[0], this._offset[1] + this._size[1]]]
                };

                this._options.set('shape', iconShape);
                this._applyElementOffset(this._offset);
                this._bindEvents();
            },

            _bindEvents() {
                if (!this.inited) {
                    this.inited = true;
                    this.innerWidth = window.innerWidth;

                    window.addEventListener('resize', () => {
                        if (window.innerWidth !== this.innerWidth) {
                            this.innerWidth = window.innerWidth;
                            this.rebuild();
                        }
                    });
                }
            },

            _calcElementOffset() {
                switch (element.modifyClass) {
                    case 'object-image':
                        return [-this._size[0] * 2, -this._size[1] / 2];
                    case 'complex':
                    case 'infrastructure':
                    case 'commerce':
                    default:
                        return [-this._size[0] / 2, -this._size[1] / 2];
                }
            },

            _applyElementOffset(offset) {
                this._$element[0].style.marginLeft = `${offset[0]}px`;
                this._$element[0].style.marginTop = `${offset[1]}px`;
            }
        });
    }

    /**
     * Метод устанавливает настройки для балуна
     * @param {object} marker - элемент массива данных markers
     * @private
     */
    _setSettings(marker) {
        const def = {};

        def.lat = 59.939014;
        def.lon = 30.315545;
        def.iconWidth = 24;
        def.iconHeight = 24;
        def.offsetTop = 0;
        def.offsetLeft = 0;

        this.type = marker.type || 'Point';
        this.coords = marker.coords || [def.lat, def.lon];
        this.iconLayout = 'default#image';
        this.iconImageHref = marker.icon.src || '../../webicons/map/media/markers/marker.svg';
        this.iconImageSize = marker.icon.size || [def.iconWidth, def.iconHeight];
        this.iconImageOffset = marker.icon.offset || [def.offsetTop, def.offsetLeft];
        this.route = marker.route || false;

        // Копирует все данные из маркера в объект балуна
        this.balloon = marker;
    }

    /**
     * Инициализирует маркер без балуна.
     * @returns {object} - placemark объект маркера.
     * @private
     */
    _initWithoutBalloon() {
        return new this.ymaps.Placemark(this.coords, {type: this.type}, {
            iconLayout     : this.iconLayout,
            iconImageHref  : this.iconImageHref,
            iconImageSize  : this.iconImageSize,
            iconImageOffset: this.iconImageOffset
        });
    }

    /**
     * Инициализирует маркер с балуном.
     * @returns {object} - placemark объект маркера.
     * @private
     */
    _initWithBalloon() {
        this._setTemplateBalloon();

        const marker = new this.ymaps.Placemark(this.coords, {type: this.type}, {
            balloonLayout        : this._createBalloonContentLayout(),
            iconLayout           : this.iconLayout,
            iconImageHref        : this.iconImageHref,
            iconImageSize        : this.iconImageSize,
            iconImageOffset      : this.iconImageOffset,
            // текущий шаблон для баллуна
            template             : this.balloonTemplate,
            // все данные от бэкенда
            data                 : this.balloon,
            hideIconOnBalloonOpen: false
        });

        this._bindEventsMarker(marker);

        return marker;
    }

    /**
     * Устанавливает шаблон для маркера исходя из модификатора.
     * @param {object} element - данные для маркера от бэкенда.
     * @private
     */
    _setTemplateMarker(element) {
        switch (element.modifyClass) {
            case 'yandex-map-balloon_theme_routes':
                this.hideIconOnBalloonOpen = false;
                this.markerTemplate = aboutMarkerTemplate;
                break;
            case 'object':
            case 'object-image':
                this.hideIconOnBalloonOpen = false;
                this.markerTemplate = contactsMarkerTemplate;
                break;
            case 'infrastructure':
                this.hideIconOnBalloonOpen = false;
                this.markerTemplate = infrastructureMarkerTemplate;
                break;
            case 'commerce':
                this.hideIconOnBalloonOpen = false;
                this.markerTemplate = commerceMarkerTemplate;
                break;
            default:
                this.hideIconOnBalloonOpen = false;
                this.markerTemplate = markerTemplate;
                break;
        }
    }

    /**
     * Устанавливает шаблон для баллуна исходя из модификатора.
     * @param {object} element - данные для маркера от бэкенда
     */
    _setTemplateBalloon(element) {
        switch (element.modifyClass) {
            case 'yandex-map-balloon_theme_routes':
                this.balloonTemplate = aboutBalloonTemplate;
                break;
            case 'infrastructure':
                this.balloonTemplate = infrastructureBalloonTemplate;
                break;
            case 'commerce':
                this.balloonTemplate = commerceBalloonTemplate;
                break;
            default:
                this.balloonTemplate = balloonTemplate;
                break;
        }
    }

    /**
     * Создает шаблон балуна
     * @returns {object} - шаблон балуна для использования в методе инициализации маркеров.
     * @private
     */
    _createBalloonContentLayout() {
        const that = this;
        const BalloonLayout = this.ymaps.templateLayoutFactory.createClass(this.balloonTemplate(this.balloon), {

            /**
             * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
             */
            build() {
                this.constructor.superclass.build.call(this);
                this.balloon = document.querySelector('.j-yandex-map-balloon');

                that.balloonOffset(this.balloon);
            },

            /**
             * Удаляет содержимое макета из DOM.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
             */
            clear() {
                this.constructor.superclass.clear.call(this);
            },

            /**
             * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
             * @param {event} event - событие
             */
            onCloseClick(event) {
                event.preventDefault();

                this.events.fire('userclose');
            },

            /**
             * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
             */
            onSublayoutSizeChange() {
                BalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                if (!this.balloon) {
                    return;
                }

                this.events.fire('shapechange');
            },

            /**
             * Используется для автопозиционирования (balloonAutoPan).
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
             * @returns {object} - Координаты левого верхнего и правого нижнего углов шаблона относительни точки привязки.
             */
            getShape() {
                if (!this.balloon) {
                    return BalloonLayout.superclass.getShape.call(this);
                }

                const balloonHeight = this.balloon.offsetHeight;
                const balloonWidth = this.balloon.offsetWidth;
                const positionTop = this.balloon.offsetTop;
                const positionLeft = this.balloon.offsetLeft;

                const bounds =
                    [[positionLeft, positionTop], [positionLeft + balloonWidth, positionTop + balloonHeight]];

                return new window.ymaps.shape.Rectangle(new window.ymaps.geometry.pixel.Rectangle(bounds));
            }
        });

        return BalloonLayout;
    }

    /**
     * Метод сдвигает балун, чтобы "хвостик" указывал на точку привязки.
     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
     * @param {object} balloon - DOM элемент балуна
     */
    balloonOffset(balloon) {
        this._balloonSize = [balloon.offsetWidth, balloon.offsetHeight];
        this._balloonIconHeight = this.balloon.icon.size.height;

        balloon.style.top = this._calcTopBalloonOffset();
        balloon.style.left = `${-(this._balloonSize[0] / 2)}px`;
    }

    _calcTopBalloonOffset() {
        switch (this.balloon.modifyClass) {
            case 'object':
                return `${-(this._balloonSize[1] + (this._balloonIconHeight / 2))}px`;
            default:
                return `${-(this._balloonSize[1] + this._balloonIconHeight)}px`;
        }
    }

    /**
     * Навешивает обработчки события клик по карте и геобъектам для закрытия балунов.
     * @param {object} map - Экзмепляр созданной карты.
     * @public
     */
    closeBalloonOnClickMap(map) {
        if (window.innerWidth < this.desktopBreakpoint) {
            map.geoObjects.events.add('click', () => {
                if (map.balloon.isOpen()) {
                    map.balloon.close();
                }
            });

            map.events.add('click', () => {
                if (map.balloon.isOpen()) {
                    map.balloon.close();
                }
            });
        }
    }

    /**
     * Биндим события маркера
     * @param {Object} marker - текущий маркер
     */
    _bindEventsMarker(marker) {
        if (window.innerWidth >= this.desktopBreakpoint) {
            marker.events.add('mouseenter', this.onMouseenterMarker.bind(this));
            marker.events.add('mousemove', this.onMousemoveMarker.bind(this));
            marker.events.add('mouseleave', this.onMouseleaveMarker.bind(this));
        } else {
            marker.events.add('click', this.onMouseenterMarker.bind(this));
        }
    }

    /**
     * Событие при наведении мышки на маркер
     * @param {Object} event - объект события наведения мышки
     */
    onMouseenterMarker(event) {
        const target = event.get('target');
        const balloon = target.balloon;

        if (mapUtils.needBalloonPanel() && target.options.get('isBalloon')) {
            panel.open(target);
        } else {
            this.bindEventsBalloon(balloon);
        }
    }

    /**
     * Событие при движении мышки над маркером
     * @param {Object} event - объект события движении мышки над маркером
     */
    onMousemoveMarker(event) {
        const balloon = event.get('target').balloon;
        const isOpen = balloon.isOpen();

        if (!isOpen) {
            balloon.open();
        }
    }

    /**
     * Событие при убирания мышки с маркера
     * @param {Object} event - объект события убирания мышки с маркера
     */
    onMouseleaveMarker(event) {
        const balloon = event.get('target').balloon;

        this.timerCloseBalloon = this.getSetTimeoutClosingBalloon(balloon);
    }

    /**
     * Биндим события балуна
     * @param {Object} balloon - текущий балун
     */
    bindEventsBalloon(balloon) {
        balloon.events.add('mouseenter', this.onMouseenterBalloon.bind(this));
        balloon.events.add('mouseleave', this.onMouseleaveBalloon.bind(this));
    }

    /**
     * Событие при наведении мышки на балун
     */
    onMouseenterBalloon() {
        clearTimeout(this.timerCloseBalloon);
        this.timerCloseBalloon = null;
    }

    /**
     * Событие при убирания мышки с балуна
     * @param {Object} event - объект события потери мышки с балуна
     */
    onMouseleaveBalloon(event) {
        const balloon = event.get('target').balloon;

        this.getSetTimeoutClosingBalloon(balloon);
    }

    /**
     * Получение id установленного таймаута закрытия
     * @param {Object} balloon - текущий балун
     * @return {number} -
     */
    getSetTimeoutClosingBalloon(balloon) {
        const timeDelayClosing = 100;

        return setTimeout(() => {
            balloon.close();
        }, timeDelayClosing);
    }
}

export default Marker;
